import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVInspectionArea } from 'types'

const StyledEyeClosedIcon = styled(EyeNoneIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

const StyledEyeOpenIcon = styled(EyeOpenIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ToggleInspectionAreaVisibilityButton: FC<{
  inspectionArea: KVInspectionArea
}> = ({ inspectionArea }) => {
  const { updateInspectionArea } = useKestrel()

  const toggleVisibility = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isVisible = inspectionArea.visible
    if (updateInspectionArea)
      updateInspectionArea(
        inspectionArea,
        'inspectionAreaVisible',
        (a: KVInspectionArea) => {
          a.visible = !isVisible
          return a
        },
        !isVisible
      )
  }

  return (
    <TooltipWrapper
      label={
        inspectionArea.visible ? 'Hide inspection area' : 'Show inspection area'
      }
      side='top'>
      <div style={{ cursor: 'pointer' }} onClick={(e) => toggleVisibility(e)}>
        {inspectionArea.visible ? (
          <StyledEyeOpenIcon width={22} height={22} />
        ) : (
          <StyledEyeClosedIcon width={22} height={22} />
        )}
      </div>
    </TooltipWrapper>
  )
}
